<template>
  <span class="app-table-user">
    <template v-if="hasUser">
      <span class="app-table-user__avatar" aria-hidden="true">
        <img v-if="photo && !photoFailed" :src="photo" alt="" @error="photoFailed = true">
        <i v-else class="pi pi-user" />
      </span>
      <AppTableText :text="name" :tooltip="tooltip"><slot>{{ (name || '').trim() || '—' }}</slot></AppTableText>
    </template>
    <span v-else>—</span>
  </span>
</template>

<script>
import AppTableText from '@/components/AppTableText.vue'

export default {
  name: 'AppTableUser',
  components: { AppTableText },
  props: {
    name: { type: String, default: '' },
    photo: { type: String, default: '' },
    tooltip: { type: String, default: '' }
  },
  data() {
    return { photoFailed: false }
  },
  computed: {
    hasUser() {
      return Boolean((this.name || '').trim() || this.photo)
    }
  },
  watch: {
    photo() {
      this.photoFailed = false
    }
  }
}
</script>

<style lang="scss" scoped>
.app-table-user {
  display: flex;
  min-width: 0;
  max-width: 100%;
  align-items: center;
  gap: $ui-space-8;
  white-space: nowrap;

  &__avatar {
    display: inline-flex;
    width: 28px;
    height: 28px;
    flex: 0 0 28px;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    border: 1px solid $ui-line-strong;
    border-radius: 50%;
    background: $ui-surface-soft;
    color: $ui-muted;
    font-size: 14px;
  }

  &__avatar img { width: 100%; height: 100%; object-fit: cover; }
}
</style>
